import { LOAD_DEMANDS, SELECT_DEMAND, CLEAN_SELECTED_DEMAND } from "./actionTypes";

export const loadDemands = demands => ({
    type: LOAD_DEMANDS,
    demands
});

export const chooseDemand = demand => ({
    type: SELECT_DEMAND,
    demand
});

export const cleanDemand = () => ({
    type: CLEAN_SELECTED_DEMAND
});